<script setup lang="ts">
usePageSeo('seoVideosTitle', 'seoVideosDescription');

const videos = [
  {
    titleKey: 'videoTitlePromotion',
    src: 'https://res.cloudinary.com/dlct0dnwt/video/upload/v1707660416/refuge/videos/refuge_promotion_rvvdsg.mp4',
    important: true
  },
  {
    titleKey: 'videoTitleDrone',
    src: 'https://res.cloudinary.com/dlct0dnwt/video/upload/v1685569770/refuge/videos/drone_overhead.mp4',
    important: false
  },
  {
    titleKey: 'videoTitleTimelapse',
    src: 'https://res.cloudinary.com/dlct0dnwt/video/upload/v1668336672/refuge/videos/Timelapse_izdc98.mp4',
    important: false
  }
]
</script>

<template>
  <div class="videos-page">
    <Hero 
      :title="$t('Videos')" 
      :subtitle="$t('videoSubtitle')"
      backgroundImage="https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1684614475/refuge/outside/outside_15_v9wdcw.jpg"
    />

    <div class="content-container">
      <div class="video-layout">
        <div v-for="(video, index) in videos" 
             :key="index" 
             class="video-card"
             :class="{ 'featured': video.important }">
          <div class="video-wrapper">
            <video controls preload="metadata" width="100%">
              <source :src="video.src" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div class="video-info">
            <h3 class="video-title">{{ $t(video.titleKey) }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.videos-page
  width: 100vw

.content-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 2rem 8rem

.video-layout
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 3rem

.video-card
  display: flex
  flex-direction: column
  gap: 1.5rem
  
  &.featured
    grid-column: span 2
    
    .video-wrapper
      aspect-ratio: 16 / 9

.video-wrapper
  border-radius: $border-radius-card
  overflow: hidden
  box-shadow: $shadow-modern
  background-color: black
  aspect-ratio: 16 / 9
  
  video
    display: block
    width: 100%
    height: 100%
    object-fit: cover

.video-info
  padding: 0 0.5rem

.video-title
  font-size: 1.5rem
  font-weight: 800
  margin: 0

@media (max-width: 768px)
  .video-layout
    grid-template-columns: 1fr
  
  .video-card.featured
    grid-column: span 1
</style>
